// © Microsoft Corporation. All rights reserved.

import { DesignSystem, accentFillRest, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../utils/enums";
import { secondaryBorderColor } from "../../utils/commonJssConstants";

const avatarSize = "54px";
const borderColor = "#DDDDDD";

export const PublisherProfileCardStyles = (config: DesignSystem) =>  ({
    publisherProfileCardContainer: {
        position: "sticky",
        "z-index": "10",
        top: "0px",
        display: "flex",
        "flex-direction": "column",
        "align-items": "stretch",
        width: "240px",
        "min-width": "240px",
        margin: "3px 0",
        padding: "0",
        "& .cwt-box": {
            "border-radius": "2px",
            "-webkit-box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",
            "-moz-box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",
            "box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",
            background: neutralLayerCard,
            color: neutralForegroundRest,
            "margin-bottom": "10px",
            "& > [class$='-container'] > .cwt-inner-container": {
                padding: "16px"
            }
        },

        "& .cwt-section": {
            "border-top": "1px solid",
            "border-color": borderColor
        },

        "& .cwt-title": {
            color: neutralForegroundRest,
            "text-align": "center",
            "font-size": "14px"
        },

        "& .cwt-button-container": {
            display: "flex",
            "justify-content": "center",
            "& button.cwt-fast-button": {
                "min-width": "100px",
                padding: "8px 20px",
                "& .cwt-icon": {
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "10px"
                }
            }
        },

        "& .cwt-user-info-container": {
            "& .cwt-user-info": {
                "& .cwt-avatar-container": {
                    "& .cwt-avatar": {
                        "min-width": avatarSize,
                        "max-width": avatarSize,
                        height: avatarSize
                    }
                },
                display: "flex",
                "flex-direction": "column",

                "& .cwt-user-header": {
                    display: "flex",
                    "flex-direction": "column",
                    "align-items": "center",
                    "justify-content": "space-between",

                    "& .cwt-name-title": {
                        width: "100%",
                        "text-align": "center",

                        "& .cwt-name": {
                            "margin-top": "5px",
                            "font-size": "24px",
                            "font-weight": "600"
                        }
                    }
                }
            },
            "& .cwt-button-container": {
                "& button.outline-button-accent": {
                    color: accentFillRest,
                    "border-color": accentFillRest,
                    "& .cwt-icon": {
                        color: accentFillRest
                    }
                }
            }
        },
        "& .cwt-action-panel-container": {
            "& .action-panel-header": {
                "text-align": "center"
            },
            "& .cwt-action-panel": {
                "& .cwt-button-container": {
                    "& button.cwt-fast-button": {
                        width: "100%"
                    },
                    "& button.button-inactive": {
                        "& .cwt-icon": {
                            color: "white"
                        }
                    }
                }
            },
            "& .cwt-action-panel-text-container": {
                display: "flex",
                "justify-content": "center",

                "& .cwt-link": {
                    margin: "8px 0 0",
                    "font-size": "12px",
                    color: accentFillRest
                }
            }
        },
        "& .cwt-about-panel-container": {
            "& .cwt-about-text": {
                "font-size": "12px",
                "line-height": "20px",
                margin: "0"
            }
        },
        "& .cwt-social-panel-container": {
            "& .cwt-social": {
                display: "flex",
                "& .cwt-share-text": {
                    "font-size": "12px",
                    "font-weight": "600",
                    color: "#919191",
                    "line-height": "16px",
                    display: "flex",
                    "align-items": "center",
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "5px"
                },
                "& .cwt-share-buttons": {
                    display: "flex",
                    "align-items": "center",
                    "& .cwt-fast-icon-button": {
                        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "12px",
                        height: "unset",
                        "font-size": "16px",
                        padding: "0",
                        "min-width": "unset",
                        "& .cwt-icon": {
                            color: "#8A8886"
                        }
                    }
                }
            }
        },
        "& .cwt-fast-icon-button": {
            "& .cwt-icon": {
                "font-size": "16px"
            }
        },
        [`&.${enums.responsiveLevels.L0}`]: {
            width: "100%",
            position: "static"
        }
    },
    alreadySubscribedPopoverContainer: {
        bottom: "50px",
        [applyLocalizedProperty(
            "left",
            "right",
            config.direction
        )]: "180px"
    }
});
